export default __webpack_public_path__ + "static/media/pos.3b03fcb5.svg";